const listeners = new WeakMap();

function resize(el) {
  const style = window.getComputedStyle(el);

  el.style.height = 'auto';

  let height = el.scrollHeight;

  // scrollHeight includes padding but not borders. CSS height includes
  // borders under border-box and excludes padding under content-box.
  if (style.boxSizing === 'border-box') {
    height +=
      parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
  } else {
    height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
  }

  el.style.height = `${height}px`;
}

export default {
  mounted(el) {
    el.style.overflowY = 'hidden';

    const onResize = () => resize(el);
    listeners.set(el, onResize);
    el.addEventListener('input', onResize);
    // The old autosize library also re-measured on window resize, since
    // viewport changes can rewrap the text.
    window.addEventListener('resize', onResize);

    // This helps ensure that the initial height of the textarea will
    // be correct when the page is first loaded.
    // https://github.com/vuejs/vue/issues/9200#issuecomment-468512304
    requestAnimationFrame(() => resize(el));
  },
  updated(el) {
    resize(el);
  },
  unmounted(el) {
    const onResize = listeners.get(el);

    if (onResize) {
      el.removeEventListener('input', onResize);
      window.removeEventListener('resize', onResize);
      listeners.delete(el);
    }
  },
};
